import { useEffect } from 'react';
import { BODY_OVERFLOW_STOP_CLASS_NAME } from '../../styles/InjectGlobalStyle';
export var useCloseModalOnEscape = function useCloseModalOnEscape(show, handler) {
  useEffect(function () {
    var onEscape = function onEscape(e) {
      if (show && e.key === 'Escape') {
        handler();
      }
    };

    document.addEventListener('keyup', onEscape, true);
    return function () {
      document.removeEventListener('keyup', onEscape, true);
    };
  }, [show, handler]);
};
export var useUpdateBodyClassName = function useUpdateBodyClassName(show) {
  useEffect(function () {
    if (show) {
      document.body.classList.add(BODY_OVERFLOW_STOP_CLASS_NAME);
    } else {
      document.body.classList.remove(BODY_OVERFLOW_STOP_CLASS_NAME);
    }
  }, [show]);
};